//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchFilterModal from '~/components/modal/search/search-filter-modal.vue'
import SearchFilters from '~/components/search/search-filters.vue'
import SearchModal from '~/components/modal/search/search-modal.vue'
import searchUtils from '~/mixins/search/search-utils'

export default {
  name: 'SearchModals',
  components: { SearchModal, SearchFilters, SearchFilterModal },
  mixins: [searchUtils]

}
